module.exports = __webpack_public_path__ + "media/promo/promo/images/mob-1-f227064f2ef5772920ed386ffab08f14.png";